

// export default function UpcomingLottery(){
//     return(
// //         <div>
// //               hello Lottery
// //      <div style={{display:"flex",gap:"10px",width:"100%",border:"1px solid red"}}>

// // <div>
// // <section className="lottery-section-item-wrap-1">
// //       <div className="upcoming-draw-item-logo-box">
// //         <section className="logo-container">
// //           <img className="logo-img" alt="" src="/modules/lottery2/assets/countries-7a4535f1.png" />
// //         </section>
// //       </div>
// //       <div className="bet-address">
// //         FAST KENO 20/80
// //       </div>
// //       <div className="prize-amount">
// //         ₹254,418.84
// //       </div>
// //       <div className="divider"></div>
// //       <div className="next-draw-text">
// //         Next Draw Starts in
// //       </div>
// //       <div className="bet-next-draw-date">
// //         <span className="time-segment">00h</span>
// //         <label className="colon">:</label>
// //         <span className="time-segment">00m</span>
// //         <label className="colon">:</label>
// //         <span className="time-segment">00s</span>
// //       </div>
// //       <button className="bet-btn">
// //         Bet Now
// //       </button>
// //     </section>
// // </div>
// // <div>
// // <section className="lottery-section-item-wrap-2">
// //       <div className="upcoming-draw-item-logo-box">
// //         <section className="logo-container">
// //           <img className="logo-img" alt="" src="/modules/lottery2/assets/countries-7a4535f1.png" />
// //         </section>
// //       </div>
// //       <div className="bet-address">
// //         Slovakia EKlub Keno 20/80
// //       </div>
// //       <div className="prize-amount">
// //         ₹848,093.15
// //       </div>
// //       <div className="divider"></div>
// //       <div className="next-draw-text">
// //         Next Draw Starts in
// //       </div>
// //       <div className="bet-next-draw-date">
// //         <span className="time-segment">00h</span>
// //         <label className="colon">:</label>
// //         <span className="time-segment">00m</span>
// //         <label className="colon">:</label>
// //         <span className="time-segment">00s</span>
// //       </div>
// //       <button className="bet-btn">
// //         Bet Now
// //       </button>
// //     </section>
// // </div>
// // <div>
// // <section className="lottery-section-item-wrap-3">
// //       <div className="upcoming-draw-item-logo-box">
// //         <section className="logo-container">
// //           <img className="logo-img" alt="Keno Russia" src="/modules/lottery2/assets/countries-7a4535f1.png" />
// //         </section>
// //       </div>
// //       <div className="bet-address">
// //         Keno Russia 20/80
// //       </div>
// //       <div className="prize-amount">
// //         ₹21,202.32
// //       </div>
// //       <div className="divider"></div>
// //       <div className="next-draw-text">
// //         Next Draw Starts in
// //       </div>
// //       <div className="bet-next-draw-date">
// //         <span className="time-segment">00h</span>
// //         <label className="colon">:</label>
// //         <span className="time-segment">00m</span>
// //         <label className="colon">:</label>
// //         <span className="time-segment">00s</span>
// //       </div>
// //       <button className="bet-btn">
// //         Bet Now
// //       </button>
// //     </section>
// // </div>
// // <div>
// // <section className="lottery-section-item-wrap-4">
// //       <div className="upcoming-draw-item-logo-box">
// //         <section className="logo-container">
// //           <img className="logo-img" alt="Slovakia EKlub Keno" src="/modules/lottery2/assets/countries-7a4535f1.png" />
// //         </section>
// //       </div>
// //       <div className="bet-address">
// //         Slovakia EKlub Keno 20/80
// //       </div>
// //       <div className="prize-amount">
// //         ₹848,093.15
// //       </div>
// //       <div className="divider"></div>
// //       <div className="next-draw-text">
// //         Next Draw Starts in
// //       </div>
// //       <div className="bet-next-draw-date">
// //         <span className="time-segment">00h</span>
// //         <label className="colon">:</label>
// //         <span className="time-segment">00m</span>
// //         <label className="colon">:</label>
// //         <span className="time-segment">00s</span>
// //       </div>
// //       <button className="bet-btn">
// //         Bet Now
// //       </button>
// //     </section>
// // </div>
// //         </div>

// //         </div>
//       <div className="lottery-container">
//       <div className="lottery-section-item">
//         <section className="lottery-section-item-wrap-1">
//           <div className="upcoming-draw-item-logo-box">
//             <section className="logo-container">
//               <img className="logo-img" alt="" src="/assets/bcimages/upcominglottery/countries-7a4535f1.png" />
//             </section>
//           </div>
//           <div className="bet-address">FAST KENO 20/80</div>
//           <div className="prize-amount">₹254,418.84</div>
//           <div className="divider"></div>
//           <div className="next-draw-text">Next Draw Starts in</div>
//           <div className="bet-next-draw-date">
//             <span className="time-segment">00h</span>
//             <label className="colon">:</label>
//             <span className="time-segment">00m</span>
//             <label className="colon">:</label>
//             <span className="time-segment">00s</span>
//           </div>
//           <button className="bet-btn">Bet Now</button>
//         </section>
//       </div>

//       <div className="lottery-section-item">
//         <section className="lottery-section-item-wrap-2">
//           <div className="upcoming-draw-item-logo-box">
//             <section className="logo-container">
//               <img className="logo-img" alt="" src="/assets/bcimages/upcominglottery/countries-7a4535f1.png" />
//             </section>
//           </div>
//           <div className="bet-address">Slovakia EKlub Keno 20/80</div>
//           <div className="prize-amount">₹848,093.15</div>
//           <div className="divider"></div>
//           <div className="next-draw-text">Next Draw Starts in</div>
//           <div className="bet-next-draw-date">
//             <span className="time-segment">00h</span>
//             <label className="colon">:</label>
//             <span className="time-segment">00m</span>
//             <label className="colon">:</label>
//             <span className="time-segment">00s</span>
//           </div>
//           <button className="bet-btn">Bet Now</button>
//         </section>
//       </div>

//       <div className="lottery-section-item">
//         <section className="lottery-section-item-wrap-3">
//           <div className="upcoming-draw-item-logo-box">
//             <section className="logo-container">
//               <img className="logo-img" alt="Keno Russia" src="/assets/bcimages/upcominglottery/countries-7a4535f1.png" />
//             </section>
//           </div>
//           <div className="bet-address">Keno Russia 20/80</div>
//           <div className="prize-amount">₹21,202.32</div>
//           <div className="divider"></div>
//           <div className="next-draw-text">Next Draw Starts in</div>
//           <div className="bet-next-draw-date">
//             <span className="time-segment">00h</span>
//             <label className="colon">:</label>
//             <span className="time-segment">00m</span>
//             <label className="colon">:</label>
//             <span className="time-segment">00s</span>
//           </div>
//           <button className="bet-btn">Bet Now</button>
//         </section>
//       </div>

//       <div className="lottery-section-item">
//         <section className="lottery-section-item-wrap-4">
//           <div className="upcoming-draw-item-logo-box">
//             <section className="logo-container">
//               <img className="logo-img" alt="Slovakia EKlub Keno" src="/assets/bcimages/upcominglottery/countries-7a4535f1.png" />
//             </section>
//           </div>
//           <div className="bet-address">Slovakia EKlub Keno 20/80</div>
//           <div className="prize-amount">₹848,093.15</div>
//           <div className="divider"></div>
//           <div className="next-draw-text">Next Draw Starts in</div>
//           <div className="bet-next-draw-date">
//             <span className="time-segment">00h</span>
//             <label className="colon">:</label>
//             <span className="time-segment">00m</span>
//             <label className="colon">:</label>
//             <span className="time-segment">00s</span>
//           </div>
//           <button className="bet-btn">Bet Now</button>
//         </section>
//       </div>
//       <div className="lottery-section-item">
//         <section className="lottery-section-item-wrap-5">
//           <div className="upcoming-draw-item-logo-box">
//             <section className="logo-container">
//               <img className="logo-img" alt="Slovakia EKlub Keno" src="/assets/bcimages/upcominglottery/countries-7a4535f1.png" />
//             </section>
//           </div>
//           <div className="bet-address">Slovakia EKlub Keno 20/80</div>
//           <div className="prize-amount">₹848,093.15</div>
//           <div className="divider"></div>
//           <div className="next-draw-text">Next Draw Starts in</div>
//           <div className="bet-next-draw-date">
//             <span className="time-segment">00h</span>
//             <label className="colon">:</label>
//             <span className="time-segment">00m</span>
//             <label className="colon">:</label>
//             <span className="time-segment">00s</span>
//           </div>
//           <button className="bet-btn">Bet Now</button>
//         </section>
//       </div>
//       <div className="lottery-section-item">
//         <section className="lottery-section-item-wrap-6">
//           <div className="upcoming-draw-item-logo-box">
//             <section className="logo-container">
//               <img className="logo-img" alt="Slovakia EKlub Keno" src="/assets/bcimages/upcominglottery/countries-7a4535f1.png" />
//             </section>
//           </div>
//           <div className="bet-address">Slovakia EKlub Keno 20/80</div>
//           <div className="prize-amount">₹848,093.15</div>
//           <div className="divider"></div>
//           <div className="next-draw-text">Next Draw Starts in</div>
//           <div className="bet-next-draw-date">
//             <span className="time-segment">00h</span>
//             <label className="colon">:</label>
//             <span className="time-segment">00m</span>
//             <label className="colon">:</label>
//             <span className="time-segment">00s</span>
//           </div>
//           <button className="bet-btn">Bet Now</button>
//         </section>
//       </div>
//     </div>
   
      
    

//     )
// }
import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation,Thumbs, Mousewheel } from 'swiper/modules';

export default function UpcomingLottery() {
  const swiperRef = useRef(null);  // Using useRef hook for the swiper reference

  const breakpoints = {
    1200: {
      slidesPerView: 4, // Show 4 slides
    },
    1024: {
      slidesPerView: 4, // Show 4 slides
    },
    650: {
      slidesPerView: 3, // Show 4 slides
    },
    
    300: {
      slidesPerView: 2, // Show 4 slides
    },
  
    0: {
      slidesPerView: 1, // Show 2 slides
    },
  };

  return (
    <div className="lottery-container">
      {/* Swiper container with navigation buttons */}
      <Swiper
        loop={true}
        thumbs={true}
        // mousewheel={true}
        modules={[Navigation,Thumbs, Mousewheel]} // Enable navigation buttons
        spaceBetween={10} // Space between slides
        slidesPerView={4} // Show 4 slides at a time by default
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        }}
        breakpoints={breakpoints} // Add breakpoints configuration
        ref={swiperRef}
        className="lottery-swiper"
      >
        {/* Each SwiperSlide wraps a lottery section */}
        <SwiperSlide>
          <section className="lottery-section-item-wrap-1">
            <div className="upcoming-draw-item-logo-box">
              <section className="logo-container">
                <img
                  className="logo-img"
                  alt="Keno"
                  src="/assets/bcimages/upcominglottery/countries-7a4535f1.png"
                />
              </section>
            </div>
            <div className="bet-address">FAST KENO 20/80</div>
            <div className="prize-amount">₹254,418.84</div>
            <div className="divider"></div>
            <div className="next-draw-text">Next Draw Starts in</div>
            <div className="bet-next-draw-date">
              <span className="time-segment">00h</span>
              <label className="colon">:</label>
              <span className="time-segment">00m</span>
              <label className="colon">:</label>
              <span className="time-segment">00s</span>
            </div>
            <button className="bet-btn">Bet Now</button>
          </section>
        </SwiperSlide>

        <SwiperSlide>
          <section className="lottery-section-item-wrap-2">
            <div className="upcoming-draw-item-logo-box">
              <section className="logo-container">
                <img
                  className="logo-img"
                  alt="Keno Slovakia"
                  src="/assets/bcimages/upcominglottery/countries-7a4535f1.png"
                />
              </section>
            </div>
            <div className="bet-address">Slovakia EKlub Keno 20/80</div>
            <div className="prize-amount">₹848,093.15</div>
            <div className="divider"></div>
            <div className="next-draw-text">Next Draw Starts in</div>
            <div className="bet-next-draw-date">
              <span className="time-segment">00h</span>
              <label className="colon">:</label>
              <span className="time-segment">00m</span>
              <label className="colon">:</label>
              <span className="time-segment">00s</span>
            </div>
            <button className="bet-btn">Bet Now</button>
          </section>
        </SwiperSlide>

        {/* Add more SwiperSlide components as needed */}
        <SwiperSlide>
          <section className="lottery-section-item-wrap-3">
            <div className="upcoming-draw-item-logo-box">
              <section className="logo-container">
                <img className="logo-img" alt="Keno Russia" src="/assets/bcimages/upcominglottery/countries-7a4535f1.png" />
              </section>
            </div>
            <div className="bet-address">Keno Russia 20/80</div>
            <div className="prize-amount">₹21,202.32</div>
            <div className="divider"></div>
            <div className="next-draw-text">Next Draw Starts in</div>
            <div className="bet-next-draw-date">
              <span className="time-segment">00h</span>
              <label className="colon">:</label>
              <span className="time-segment">00m</span>
              <label className="colon">:</label>
              <span className="time-segment">00s</span>
            </div>
            <button className="bet-btn">Bet Now</button>
          </section>
        </SwiperSlide>

        <SwiperSlide>
          <section className="lottery-section-item-wrap-4">
            <div className="upcoming-draw-item-logo-box">
              <section className="logo-container">
                <img className="logo-img" alt="Slovakia EKlub Keno" src="/assets/bcimages/upcominglottery/countries-7a4535f1.png" />
              </section>
            </div>
            <div className="bet-address">Slovakia EKlub Keno 20/80</div>
            <div className="prize-amount">₹848,093.15</div>
            <div className="divider"></div>
            <div className="next-draw-text">Next Draw Starts in</div>
            <div className="bet-next-draw-date">
              <span className="time-segment">00h</span>
              <label className="colon">:</label>
              <span className="time-segment">00m</span>
              <label className="colon">:</label>
              <span className="time-segment">00s</span>
            </div>
            <button className="bet-btn">Bet Now</button>
          </section>
        </SwiperSlide>

        <SwiperSlide>
          <section className="lottery-section-item-wrap-5">
            <div className="upcoming-draw-item-logo-box">
              <section className="logo-container">
                <img className="logo-img" alt="Slovakia EKlub Keno" src="/assets/bcimages/upcominglottery/countries-7a4535f1.png" />
              </section>
            </div>
            <div className="bet-address">Slovakia EKlub Keno 20/80</div>
            <div className="prize-amount">₹848,093.15</div>
            <div className="divider"></div>
            <div className="next-draw-text">Next Draw Starts in</div>
            <div className="bet-next-draw-date">
              <span className="time-segment">00h</span>
              <label className="colon">:</label>
              <span className="time-segment">00m</span>
              <label className="colon">:</label>
              <span className="time-segment">00s</span>
            </div>
            <button className="bet-btn">Bet Now</button>
          </section>
        </SwiperSlide>

        <SwiperSlide>
          <section className="lottery-section-item-wrap-6">
            <div className="upcoming-draw-item-logo-box">
              <section className="logo-container">
                <img className="logo-img" alt="Slovakia EKlub Keno" src="/assets/bcimages/upcominglottery/countries-7a4535f1.png" />
              </section>
            </div>
            <div className="bet-address">Slovakia EKlub Keno 20/80</div>
            <div className="prize-amount">₹848,093.15</div>
            <div className="divider"></div>
            <div className="next-draw-text">Next Draw Starts in</div>
            <div className="bet-next-draw-date">
              <span className="time-segment">00h</span>
              <label className="colon">:</label>
              <span className="time-segment">00m</span>
              <label className="colon">:</label>
              <span className="time-segment">00s</span>
            </div>
            <button className="bet-btn">Bet Now</button>
          </section>
        </SwiperSlide>

      </Swiper>

      {/* Swiper Navigation Buttons */}
      {/* <div className="swiper-button-prev">Prev</div>
      <div className="swiper-button-next">Next</div> */}
    </div>
  );
}
